"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typedi_1 = require("typedi");
const popup_1 = require("./services/popup");
window.PopupController = typedi_1.Container.get(popup_1.PopupService);
require("./templates/login");
require("./templates/signup");
require("./templates/password-recovery");
require("./templates/reserved");
require("./templates/subscribe");
require("./templates/support");
require("./templates/cart-fail");
require("./templates/school-guarantee");
require("./templates/community-programme-request");
require("./templates/verification");
require("./templates/contact");
require("./templates/fast-track");
require("./templates/art-records");
require("./templates/spinner-services");
require("./templates/checkout");
require("./templates/loading");
